<template>
  <v-select
    :value="value"
    @input="value => emit(value)"
    :label="config.label"
    :items="availabilities"
    item-text="name"
    item-value="code"
    :required="config.required"
    :error="haveErrors()"
    :rules="config.errors"
    dark>
  </v-select>
</template>

<script>
  import input from '@/mixins/input'
  export default {
    mixins: [input],
    computed: {
      availabilities () {
        return ['chat']
          .map(e => ({ code: e, name: this.$t(`inputs.availabilitytype.types.${e}`) }))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/AvailabilityType.vue